import { api } from 'app/config/apiConfig';

export const sendContractByEmailApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendContractByEmail: builder.mutation<void, string>({
      query: (contractId) => ({
        url: `/contracts/${contractId}/send-contract`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useSendContractByEmailMutation } = sendContractByEmailApi;
